import { render } from "./Skill_Ratings.vue?vue&type=template&id=66451b1e"
import script from "./Skill_Ratings.vue?vue&type=script&lang=js"
export * from "./Skill_Ratings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__